import { createReducer } from '../utils';

export const HEALTH_ENROLLMENT_STATUS_ACTIONS = {
  STARTED: 'FETCH_HEALTH_ENROLLMENT_STATUS_STARTED',
  SUCCEEDED: 'FETCH_HEALTH_ENROLLMENT_STATUS_SUCCEEDED',
  FAILED: 'FETCH_HEALTH_ENROLLMENT_STATUS_FAILED',
  RESET: 'RESET_HEALTH_ENROLLMENT_STATUS',
};

export const HEALTH_ENROLLMENT_STATUS_INIT_STATE = {
  loading: false,
  fetchAttempted: false,
  hasServerError: false,
  hasRateLimitError: false,
  recordNotFound: false,
  parsedStatus: null,
  applicationDate: null,
  enrollmentDate: null,
  effectiveDate: null,
  preferredFacility: null,
  primaryEligibility: null,
  priorityGroup: null,
  canSubmitFinancialInfo: null,
};

const { STARTED, SUCCEEDED, FAILED, RESET } = HEALTH_ENROLLMENT_STATUS_ACTIONS;

export const healthEnrollmentStatusReducer = createReducer(
  HEALTH_ENROLLMENT_STATUS_INIT_STATE,
  {
    [STARTED]: state => ({ ...state, loading: true }),
    [SUCCEEDED]: (state, { response }) => ({
      ...state,
      ...response,
      loading: false,
      fetchAttempted: true,
      hasServerError: false,
      hasRateLimitError: false,
      recordNotFound: false,
    }),
    [FAILED]: (state, { errors }) => {
      const recordNotFound =
        errors?.some(({ code }) => code === '404') ?? false;
      const hasRateLimitError =
        errors?.some(({ code }) => code === '429') ?? false;
      return {
        ...state,
        loading: false,
        fetchAttempted: true,
        recordNotFound,
        hasRateLimitError,
        hasServerError: !recordNotFound && !hasRateLimitError,
      };
    },
    [RESET]: () => ({ ...HEALTH_ENROLLMENT_STATUS_INIT_STATE }),
  },
);
